export default __webpack_public_path__ + "53e02b634e42240b89d8cd942c7a4ae8.ttf";